import { getAppChatApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { AppChatApiGetAppChatMessageEditsRequest, ChatMessageEditResponse } from '@/core/generated/api';

/** Загружает историю правок в области выбранного владельца */
export const chatEditHistoryService = {
    /** Получает страницу сохранённых версий */
    async get(
        request: AppChatApiGetAppChatMessageEditsRequest
    ): Promise<ChatMessageEditResponse[]> {
        try {
            return (await getAppChatApi().getAppChatMessageEdits(request)).data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
